import { TextField } from '@mui/material';
import React, { useMemo, useRef, useState, useCallback } from 'react';

import { CodeValidator } from '../common/validation/code-validator';

export const DEFAULT_OTP_VALUE_LENGTH = 6;

export type OTPFieldProps = {
  valueLength?: number;
  cleanOnSubmitEnabled?: boolean;
  autoSubmitEnabled?: boolean;
  blurOnSubmitEnabled?: boolean;
  autoFocus?: boolean;
  onSubmit(value: string): void;
  label?: string;
};

export const OTPField = (props: OTPFieldProps) => {
  const {
    valueLength = DEFAULT_OTP_VALUE_LENGTH,
    cleanOnSubmitEnabled = false,
    autoSubmitEnabled = false,
    blurOnSubmitEnabled = false,
    autoFocus = false,
    onSubmit,
    label,
  } = props;
  const [value, setValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  const valueValidation = useMemo(() => CodeValidator.maxLenght(valueLength), [valueLength]);
  const completedValidation = useMemo(() => CodeValidator.exactLength(valueLength), [valueLength]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      if (!valueValidation.validate(value, { allowEmpty: true }).success) {
        return;
      }
      setValue(value);
      if (!completedValidation.validate(value, { allowEmpty: true }).success) {
        return;
      }
      if (autoSubmitEnabled) {
        onSubmit(value);
      }
      if (cleanOnSubmitEnabled) {
        setValue('');
      }
      if (blurOnSubmitEnabled) {
        inputRef.current?.blur();
      }
    },
    [autoSubmitEnabled, blurOnSubmitEnabled, cleanOnSubmitEnabled, completedValidation, onSubmit, valueValidation],
  );

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleChange}
      inputRef={inputRef}
      autoFocus={autoFocus}
      inputProps={{
        autocomplete: 'one-time-code', // Enable OTP prefill for IOS
        type: 'text', // Required to make prefill OTP from SMS working for IOS devices
        inputmode: 'numeric',
        pattern: '[0-9]*',
      }}
      fullWidth
    />
  );
};
